import moment from 'moment/moment';

const dashboardStore = {
  namespaced: true,
  state: () => ({
    searchDateDashboard: {
      type: 'dashboard',
      tab1value: '24h',
      isRefreshPlay: true,
      refreshInterval: '1',
      dateType: 1,
      queryStartDt: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
      queryEndDt: moment().format('YYYY-MM-DD HH:mm')
    }
  }),
  getters: {
    searchDateDashboard: (state) => () => {
      return state.searchDateDashboard;
    }
  },
  mutations: {
    setSearchDateDashboard: (state, payload) => (state.searchDateDashboard = payload)
  },
  actions: {
    setSearchDateDashboard: ({ commit }, data) => commit('setSearchDateDashboard', data)
  }
};

export default dashboardStore;
